import React from 'react'

import Context from 'admin/services/Context'
import { ContextType } from 'admin/types'

/**
 * HOC that injects context as props
 */
function withContext(Component: React.ComponentType) {
  return function(props) {
    return <Context.Consumer>
      {(value: ContextType) => <Component {...value} {...props} />}
    </Context.Consumer>
  }
}

export {
  withContext,
  ContextType as WithContextProps,
}
